export default __webpack_public_path__ + "static/Home-1280-da2168c1c3708c9013f93e33b922f939.webp";